export const HOST_EVENTS_NAVIGATION_STATE = Object.freeze({
  audienceMode: "host",
  hostPanelTab: "events",
});

export const getHostEventAttentionTotal = (
  waitlistUnread,
  participantRequestUnread,
  hostFeedbackUnread = 0
) =>
  Math.max(0, Number(waitlistUnread) || 0) +
  Math.max(0, Number(participantRequestUnread) || 0) +
  Math.max(0, Number(hostFeedbackUnread) || 0);

export const buildEventsNavigationState = (
  waitlistUnread,
  participantRequestUnread,
  hostFeedbackUnread = 0
) =>
  getHostEventAttentionTotal(
    waitlistUnread,
    participantRequestUnread,
    hostFeedbackUnread
  ) > 0
    ? { ...HOST_EVENTS_NAVIGATION_STATE }
    : null;
